import { useCallback, useEffect } from 'react';
import { loadEngine } from './engine';
import { type MJMLJsonObject, jsonToXML } from './xml';

type Mjml2HtmlResponse = { success: true; html: string } | { success: false };

const useLoadMjmlBrowser = () => {
  useEffect(() => {
    loadEngine();
  }, []);
};

export const useMjml2Html = () => {
  useLoadMjmlBrowser();

  return useCallback(
    async (mjml: MJMLJsonObject): Promise<Mjml2HtmlResponse> => {
      const xml = jsonToXML(mjml);
      const engine = await loadEngine();
      const result = engine.toHtml(xml);

      if (result.type === 'success') {
        return { success: true, html: result.content };
      }

      return { success: false };
    },
    []
  );
};
